import { DataBean } from "../DataBean";

export class Technicians extends DataBean {

  public async getTechniciansCatalogPorPropiedades( properties: any, maxRows: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getTechniciansCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getTechniciansRender( page: number, rows: number, properties: any ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.advantage.shared.Report_getTechniciansRender_Number_Number_java.util.Map",
      [page, rows, properties]
    );
  }

  public async deleteTechnicians(idtechnicians: number): Promise<any> {
      return this.getCustomService("ProcessContractERP", "boolean_deleteTechnicians_Number", [idtechnicians]);
  }

  public async updateTechnicians(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.Technicians_updateTechnicians_com.orange.finance.processcontract.bean.Technicians",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.Technicians",
        },
      ]
    );
  }
}
